import { getOrganizationTypesApi } from '../../services/dictionaries';
import { setOrganizationTypes } from '../actions/dictionaries';
import { message } from 'antd';
import i18n from '../../i18n';

export const loadOrganizationTypes = () => async (dispatch) => {
  try {
    const response = await getOrganizationTypesApi();
    const result = response.data;
    dispatch(setOrganizationTypes(result));
  } catch (error) {
    message.error(i18n.t('error.loadingData'));
  }
};
